import { assetCodesByAssetClass } from "@domains/mapper/Reports/AssetsAndProducts";
import { roundUpToTwoDecimalPlaces } from "@domains/utils/numberMethods";
export function holdingMapper(data) {
    if (data) {
        const initial = new Array();
        const { holdingDetail, holdingSummary, isOmneOnly, isBodEnabled, bodProcessInfoMessage } = data;
        const mappedHoldingDetails = holdingDetail.reduce((acc, record, idx) => {
            acc.push(Object.assign(Object.assign({}, record), { displayName: record.quote.displayName, changePercentage: roundUpToTwoDecimalPlaces(Number(record.quote.changePercentage)), scripIdentifier: record.scripIdentifier, rowNumber: idx, lastTradedPrice: record.quote.lastTradedPrice, quote: Object.assign(Object.assign({}, record.quote), { assetCode: record.quote.assetCode
                        ? record.quote.assetCode
                        : assetCodesByAssetClass.get(record.edelweissAssetClass.toLowerCase()) }) }));
            return acc;
        }, initial);
        return {
            HoldingDetails: mappedHoldingDetails,
            HoldingSummary: holdingSummary,
            isOmneOnly: isOmneOnly,
            isBodEnabled: isBodEnabled,
            bodProcessInfoMessage: bodProcessInfoMessage
        };
    }
    else {
        return null;
    }
}
